import * as React from 'react';
import { useAuth } from 'react-oidc-context';
import { observer } from 'mobx-react';
import authStore from './store/Auth';
import dataStore from './store';
import socketStore from './store/Socket';
import AppSwitchPage from './pages/client';
import Login from './pages/login';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Box, Container, Typography } from '@mui/material';
import CompanyLogo from './components/CompanyLogo';
import { toJS } from 'mobx';

const ProtectedRoute: React.FC<{ children: React.ReactElement; isLogin: any }> =
  observer(({ children, isLogin }) => {
    if (isLogin.isLoading) {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
          }}
        >
          <Container
            maxWidth='lg'
            sx={{
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <CompanyLogo />
            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Container
                maxWidth='xs'
                sx={{
                  boxShadow: 0,
                  backgroundColor: 'white',
                  borderRadius: 6,
                  p: 3,
                  border: '2px solid #ff5f1f',
                  fontFamily: "'Source Sans 3', sans-serif",
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                  <Typography variant='body1'>Loading...</Typography>
                </Box>
              </Container>
            </Box>
          </Container>
        </Box>
      );
    }
    if (isLogin.isAuthenticated === false && isLogin.isLoading === false) {
      return <Navigate to='/login' replace />;
    }
    return children;
  });

const App = observer(() => {
  const auth = useAuth();
  const [isLogin, setIsLogin] = React.useState({});
  dataStore.getBackendVersion();
  React.useEffect(() => {
    authStore.setUser(auth);
    setIsLogin(auth);
    if (authStore?.user?.isAuthenticated) {
      socketStore.connect();
      authStore.storeUserId();
      if (window.history.replaceState) {
        const url = new URL(window.location.href);
        url.search = '';
        window.history.replaceState({}, document.title, url);
        dataStore.getUserInternalInfo();
      }
    }
  }, [auth]);
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path='/*'
          element={
            <ProtectedRoute isLogin={isLogin}>
              <AppSwitchPage />
            </ProtectedRoute>
          }
        />
        <Route path='/login' element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
});

export default App;
